<template>
    <nav class="uk-navbar-container" uk-navbar>
        <div class="uk-navbar-left">
            <router-link to="/"><img class="navlogo pb-2" src="../../CUSTOM/assets/logo.png"/></router-link>
            <ul class="uk-navbar-nav">
                <li class="uk-margin-small-left uk-visible@s">{{$store.state.core.config.generalData.displayName || ''}}</li>
            </ul>
        </div>
        <div class="uk-navbar-right">
            <ul class="uk-navbar-nav">
                <li>
                    <div v-if="$store.state.core.user" class="uk-inline">
                        <div><img class="round uk-margin-small-right" :src="$store.state.core.user.photoURL" width="40"/><span class="uk-visible@m uk-margin-small-right">{{$store.state.core.user.displayName}}</span></div>
                        <div uk-dropdown="pos: bottom-justify">
                            <ul class="uk-nav uk-dropdown-nav">
                                <li><router-link to="profile">Profiel</router-link></li>
                                <li><a class="uk-text-danger" href="#" @click.prevent="logout">Afmelden</a></li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>
<script>
import {auth} from '@/CUSTOM/helpers/firebase'
export default {
    name: 'AppHeader', 
    methods: {
        logout () {
        auth.signOut().then(success => {
            this.$router.push('/login')
        })
        
        }
    }
}
</script>
<style scoped>
    .uk-navbar-container {
        height: 50px;
    }
</style>


// WEBPACK FOOTER //
// AppHeader.vue?528bcf6a